module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ui_title_line', [_vm._v("\n      ОПЛАТА\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "row pre-title"
  }, [_c('div', {
    staticClass: "col offset-md-2 col-md-8"
  }, [_c('Pay')], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c10a19ca","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Payment/payment.vue
// module id = 377
// module chunks = 2